import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { CharacteristicApi, CharacteristicsGridDto, CharacteristicSearch } from "../../../../api";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ViewButton, EditButton, SearchTablePage } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";

export interface ICharacteristicsListPageProps {}

export const CharacteristicsListPage: React.FunctionComponent<ICharacteristicsListPageProps> = (props) => {
  const api = useApiService(CharacteristicApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CharacteristicsGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.characteristics}/${row.characteristicId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.characteristics}/${row.characteristicId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.CharacteristicType),
        fieldName: "characteristicType",
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code",
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.AppliedToDysplasia),
        fieldName: "appliedToDysplasia",
      },
      {
        header: () => t(ETLCodes.Laboratory),
        fieldName: "labName",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.characteristics}/0/detail/edit`);
  }, [history]);

  const searchCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);

  const searchFunction = React.useCallback(
    (sObj) => api.baseSearch(CharacteristicSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  const exportFunction = React.useCallback(
    (sObj) => api.exportXlsFile(CharacteristicSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchCriteriasFunction}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      addFunc={addItemFunction}
      sortKeys={{ characteristicType: "ASC", code: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Characteristics) }]}
    />
  );
};
